import { statusBiometric } from './statusBiometric'
import { childStatusBiometric } from './childStatusBiometric'
import { processBiometric } from './processBiometric'
import { processChildBiometric } from './processChildBiometric'
import { revokeBiometric } from './revokeBiometric'
import { approveChildBiometric } from './approveChildBiometric'

export default {
  status: statusBiometric,
  childStatus: childStatusBiometric,
  process: processBiometric,
  processChild: processChildBiometric,
  revoke: revokeBiometric,
  approveChild: approveChildBiometric
}
